(() => {
  const root = document.querySelector('[data-rhp-review-root]:is([data-product-handle="red-bull-extreme-honey"],:is([data-product-handle="loriz-premium-shilajit-honey"],[data-product-handle="premium-honey-sachets-individually-packed"],[data-product-handle="php-royal-honey-supplement"]))');
  if (!root || root.dataset.questionsBound) return;
  root.dataset.questionsBound = 'true';
  const tabs = [...root.querySelectorAll('[data-feedback-tab]')];
  const spanish = root.dataset.reviewLocale === 'es';
  const localizedCount = count => Number(count || 0).toLocaleString(spanish ? 'es-ES' : 'en-US');
  const syncCounts = () => {
    tabs[0].textContent = `${spanish ? 'Reseñas' : 'Reviews'} (${localizedCount(root.dataset.reviewCount)})`;
    if (root.dataset.questionCount !== undefined) tabs[1].textContent = `${spanish ? 'Preguntas' : 'Questions'} (${localizedCount(root.dataset.questionCount)})`;
  };
  new MutationObserver(syncCounts).observe(root, { attributes: true, attributeFilter: ['data-review-count', 'data-question-count'] });
  syncCounts();
  const questions = root.querySelector('#rhp-questions-panel');
  const controls = root.querySelector('.rhp-review-controls');
  const layout = root.querySelector('.rhp-product-reviews__layout');
  const reviews = document.createElement('section');
  reviews.id = 'rhp-reviews-panel';
  reviews.setAttribute('role', 'tabpanel');
  reviews.setAttribute('aria-labelledby', 'rhp-reviews-tab');
  controls.before(reviews);
  reviews.append(controls, layout);
  let loaded = false, loading = false;
  // Rebuild vendor content with a small formatting allowlist. Never insert its
  // scripts, event attributes, forms or remote embeds into the storefront.
  const copyContent = (source, destination) => {
    const formatting = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'UL', 'OL', 'LI', 'BLOCKQUOTE']);
    const excluded = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'IFRAME', 'OBJECT', 'SVG', 'MATH', 'FORM']);
    [...source.childNodes].forEach(node => {
      if (node.nodeType === 3) { destination.append(document.createTextNode(node.textContent)); return; }
      if (node.nodeType !== 1 || excluded.has(node.tagName)) return;
      if (!formatting.has(node.tagName)) { copyContent(node, destination); return; }
      const element = document.createElement(node.tagName.toLowerCase());
      copyContent(node, element);
      destination.append(element);
    });
  };
  const renderQuestion = entry => {
    const article = document.createElement('article');
    article.className = 'rhp-question';
    const body = entry.querySelector('.jdgm-quest__body');
    if (!body) { copyContent(entry, article); return article; }
    const header = document.createElement('header');
    const asker = entry.querySelector('.jdgm-quest__asker');
    const name = asker?.querySelector('.jdgm-rev__author') || asker;
    if (name?.textContent.trim()) {
      const author = document.createElement('strong');
      author.className = 'rhp-question-author';
      author.textContent = name.textContent.trim();
      header.append(author);
    }
    const timestamp = entry.querySelector('.jdgm-quest__timestamp, .jdgm-rev__timestamp');
    if (timestamp && !timestamp.closest('.jdgm-ans')) {
      const date = document.createElement('span');
      date.className = 'rhp-question-date';
      date.textContent = timestamp.textContent.trim();
      header.append(date);
    }
    if (header.childElementCount) article.append(header);
    const question = document.createElement('div');
    question.className = 'rhp-question-body';
    const heading = document.createElement('span');
    heading.className = 'visually-hidden'; heading.textContent = 'Question: ';
    question.append(heading); copyContent(body, question); article.append(question);
    entry.querySelectorAll('.jdgm-ans').forEach(answer => {
      const answerBody = answer.querySelector('.jdgm-ans__body');
      if (!answerBody) return;
      const reply = document.createElement('section');
      reply.className = 'rhp-question-answer';
      reply.setAttribute('aria-label', 'Answer');
      const label = document.createElement('strong');
      const answerer = answer.querySelector('.jdgm-ans__answerer .jdgm-rev__author') || answer.querySelector('.jdgm-ans__answerer');
      label.textContent = answerer?.textContent.trim() ? `Answer from ${answerer.textContent.trim()}` : 'Answer';
      const content = document.createElement('div');
      copyContent(answerBody, content);
      reply.append(label, content); article.append(reply);
    });
    return article;
  };
  const disclosure = document.createElement('details');
  disclosure.className = 'rhp-question-form';
  disclosure.innerHTML = `<summary>Ask a question</summary><form><label>Name<input name="name" autocomplete="name" required maxlength="100"></label><label>Email<input name="email" type="email" autocomplete="email" required maxlength="254"></label><label>Your question<textarea name="question_content" required maxlength="5000" rows="4"></textarea></label><p>Your name and question may be published. Your email is used to respond to your question.</p><button type="submit">Submit question</button><p data-question-submit-status role="status"></p></form>`;
  questions.prepend(disclosure);
  const form = disclosure.querySelector('form');
  let submitting = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !form.reportValidity()) return;
    const status = form.querySelector('[data-question-submit-status]');
    const button = form.querySelector('button');
    const payload = new URLSearchParams(new FormData(form));
    const submittedFields = payload.toString();
    const shop = window.Shopify?.shop || '00meii-ue.myshopify.com';
    payload.set('url', shop); payload.set('shop_domain', shop); payload.set('platform', 'shopify');
    payload.set('id', root.dataset.productId); payload.set('product_title', root.dataset.productTitle);
    payload.set('handle', root.dataset.productHandle);
    submitting = true; button.disabled = true; form.setAttribute('aria-busy', 'true');
    status.textContent = 'Submitting your question…';
    const waitTimer = window.setTimeout(() => {
      status.textContent = 'Still waiting for confirmation. Please keep this page open and do not submit the question again.';
      form.removeAttribute('aria-busy');
    }, 15000);
    try {
      const response = await fetch('https://api.judge.me/api/questions', { method: 'POST', body: payload });
      if (!response.ok) throw new Error('Question submission failed');
      if (new URLSearchParams(new FormData(form)).toString() === submittedFields) {
        status.textContent = 'Your question has been submitted. Thank you.';
        form.reset();
      } else {
        status.textContent = 'Your earlier question has been submitted. Your latest edits are still here and have not been submitted.';
      }
    } catch { status.textContent = 'We could not confirm whether your question was received. Your text is preserved. Please check for a confirmation before submitting it again.'; }
    finally { window.clearTimeout(waitTimer); submitting = false; button.disabled = false; form.removeAttribute('aria-busy'); }
  });
  const load = async (page = 1, force = false) => {
    if ((!force && loaded) || loading) return;
    loading = true;
    const paginationFocus = document.activeElement?.closest('#rhp-questions-panel .rhp-api-pagination button');
    const retryFocus = document.activeElement?.closest('#rhp-questions-panel [data-question-status] button');
    const loadFocus = paginationFocus || retryFocus;
    const shouldRestoreFocus = () => !questions.hidden && loadFocus && (document.activeElement === loadFocus || document.activeElement === document.body);
    questions.querySelectorAll('.rhp-api-pagination button').forEach(button => { button.disabled = true; });
    const status = questions.querySelector('[data-question-status]');
    status.textContent = 'Loading questions…';
    questions.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
      const params = new URLSearchParams({ product_id: root.dataset.productId, shop_domain: window.Shopify?.shop || '00meii-ue.myshopify.com', platform: 'shopify', page: String(page), per_page: '5' });
      const response = await fetch(`https://cdn.judge.me/api/questions/questions_for_widget?${params}`, { signal: controller.signal });
      if (!response.ok) throw new Error('Questions unavailable');
      const data = await response.json();
      const parsed = new DOMParser().parseFromString(data.html || '', 'text/html');
      const entries = parsed.querySelector('.jdgm-quest-widg__questions');
      if (!entries) throw new Error('Unexpected question response');
      const output = questions.querySelector('[data-question-results]');
      const restorePaginationFocus = shouldRestoreFocus();
      output.replaceChildren();
      [...entries.children].forEach(entry => output.append(renderQuestion(entry)));
      const navigation = document.createElement('nav');
      navigation.className = 'rhp-api-pagination';
      navigation.setAttribute('aria-label', 'Question pages');
      parsed.querySelectorAll('.jdgm-paginate [data-page]').forEach(link => {
        const target = Number(link.getAttribute('data-page'));
        if (!Number.isInteger(target) || target < 1) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rhp-api-pagination__button';
        button.textContent = link.textContent.trim() || String(target);
        button.setAttribute('aria-label', `Question page ${target}`);
        if (target === page) { button.setAttribute('aria-current', 'page'); button.classList.add('is-active'); }
        button.addEventListener('click', () => load(target, true));
        navigation.append(button);
      });
      if (navigation.childElementCount) output.append(navigation);
      if (restorePaginationFocus) {
        const focusTarget = navigation.querySelector('[aria-current="page"]') || output;
        if (focusTarget === output) output.tabIndex = -1;
        focusTarget.focus({ preventScroll: true });
      }
      status.textContent = entries.children.length ? '' : 'No questions yet.';
      loaded = true;
    } catch {
      status.textContent = 'Questions could not be loaded. ';
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Retry';
      retry.addEventListener('click', () => load(page, true));
      status.append(retry);
      if (retryFocus && shouldRestoreFocus()) retry.focus({ preventScroll: true });
    }
    finally {
      window.clearTimeout(timeout); loading = false; questions.removeAttribute('aria-busy');
      questions.querySelectorAll('.rhp-api-pagination button').forEach(button => { button.disabled = false; });
    }
  };
  const select = tab => {
    const showQuestions = tab.dataset.feedbackTab === 'questions';
    tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
    questions.hidden = !showQuestions;
    reviews.hidden = showQuestions;
    if (showQuestions) load();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : ['ArrowLeft', 'ArrowRight'].includes(event.key) ? (index + 1) % tabs.length : -1;
      if (next < 0) return;
      event.preventDefault(); tabs[next].focus(); select(tabs[next]);
    });
  });
})();
